import { create } from "zustand";

export const SOUNDS = [
  "turn",
  "coins",
  "card",
  "bullshit",
  "block",
  "loss",
  "elimination",
  "win",
  "tick",
] as const;
export type Sound = (typeof SOUNDS)[number];

interface SoundSettings {
  muted: boolean;
  volume: number;
  setMuted: (muted: boolean) => void;
  setVolume: (volume: number) => void;
}

const saved = (() => {
  try {
    return JSON.parse(localStorage.getItem("coup:sound") ?? "{}") as Partial<SoundSettings>;
  } catch {
    return {};
  }
})();

export const useSound = create<SoundSettings>((set, get) => {
  const persist = () =>
    localStorage.setItem(
      "coup:sound",
      JSON.stringify({ muted: get().muted, volume: get().volume }),
    );
  return {
    muted: saved.muted ?? false,
    volume: saved.volume ?? 0.7,
    setMuted: (muted) => {
      set({ muted });
      persist();
    },
    setVolume: (volume) => {
      set({ volume });
      persist();
    },
  };
});

const clips = new Map<Sound, HTMLAudioElement>();

/** Plays one clip from /sfx, respecting mute and volume. */
export function play(sound: Sound) {
  const { muted, volume } = useSound.getState();
  if (muted || volume === 0) return;
  let clip = clips.get(sound);
  if (!clip) {
    clip = new Audio(`/sfx/${sound}.wav`);
    clips.set(sound, clip);
  }
  const instance = clip.cloneNode() as HTMLAudioElement;
  instance.volume = volume;
  void instance.play().catch(() => {});
}
